"use client";

import Balancer from "react-wrap-balancer";
import { Button } from "./button";
import { HiArrowRight } from "react-icons/hi2";
import { motion } from "framer-motion";
import { Link } from "next-view-transitions";
import { useTranslations } from "next-intl";

export const Hero = () => {
  const t = useTranslations("hero");

  return (
    <div className="flex flex-col pt-40 md:pt-64 pb-20 md:pb-32 relative overflow-hidden">
      <motion.h1
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ ease: "easeOut", duration: 0.5 }}
        className="text-3xl md:text-5xl lg:text-7xl xl:text-8xl font-bold tracking-tight leading-[1.05] max-w-5xl mx-auto text-center relative z-10"
      >
        {t.rich("title", {
          one: (chunks) => <span className="block">{chunks}</span>,
          two: (chunks) => (
            <span className="block text-red-500">
              {chunks}
            </span>
          ),
        })}
      </motion.h1>

      <motion.p
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ ease: "easeOut", duration: 0.5, delay: 0.2 }}
        className="text-center mt-6 text-base md:text-xl text-muted dark:text-muted-dark max-w-3xl mx-auto relative z-10"
      >
        <Balancer>
          {t.rich("subtitle", {
            afterburn: (chunks) => (
              <a
                href="#afterburn"
                className="text-neutral-900 dark:text-white font-semibold hover:underline underline-offset-4"
              >
                {chunks}
              </a>
            ),
          })}
        </Balancer>
      </motion.p>

      <motion.div
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ ease: "easeOut", duration: 0.5, delay: 0.4 }}
        className="flex items-center gap-4 justify-center mt-6 relative z-10"
      >
        <Button
          as={Link}
          href="/signup"
          className="group bg-red-600 hover:bg-red-500 text-white text-base md:text-lg font-semibold px-7 md:px-8 py-3.5 md:py-4 rounded-full transition-colors duration-200"
        >
          <span>{t("cta_primary")}</span>
          <HiArrowRight className="ml-2 h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
        </Button>
      </motion.div>
    </div>
  );
};
